import { defineMessages } from "react-intl";

const messages = defineMessages({
    status: {
        id: "choir.meta.details.status.label",
        defaultMessage: "Status"
    },
    startDate: {
        id: "choir.meta.details.startDate.label",
        defaultMessage: "Foundation date"
    },
    startDateFuture: {
        id: "choir.meta.details.startDate.future.label",
        defaultMessage: "Planned start date"
    },
    concertFrequency: {
        id: "choir.meta.details.concertFrequency.label",
        defaultMessage: "Frequency of concerts, recordings"
    },
    fundingModel: {
        id: "choir.meta.details.choirFundingModel.label",
        defaultMessage: "Funding model"
    },
    choirSize: {
        id: "choir.meta.details.choirSize.label",
        defaultMessage: "Size"
    },
    choirType: {
        id: "choir.meta.details.choirType.label",
        defaultMessage: "Type"
    },
    ageRange: {
        id: "choir.meta.details.ageRange.label",
        defaultMessage: "Age range"
    },
    proficiencyLevel: {
        id: "choir.meta.details.proficiencyLevel.label",
        defaultMessage: "Required sight-reading proficiency level"
    },
    choirCamps: {
        id: "choir.meta.details.choirCamps.label",
        defaultMessage: "Choir camps"
    },
    choirWeekEnds: {
        id: "choir.meta.details.choirWeekEnds.label",
        defaultMessage: "Choir weekends"
    },
    sectionals: {
        id: "choir.meta.details.sectionals.label",
        defaultMessage: "Sectionals"
    },
    rehearsalPreview: {
        id: "choir.meta.details.rehearsalPreview.label",
        defaultMessage: "Rehearsal preview"
    },
    repertoirSample: {
        id: "choir.meta.details.repertoirSample.label",
        defaultMessage: "Sample repertoire"
    },
    repertoirSamplePlaceholder: {
        id: "choir.meta.details.repertoirSample.placeholder",
        defaultMessage: "Placeholder..."
    },
    uniform: {
        id: "choir.meta.details.uniform.label",
        defaultMessage: "Uniform"
    },
    concertConditions: {
        id: "choir.meta.details.concertConditions.label",
        defaultMessage: "Concert conditions"
    },
    edit: {
        id: "planCard.edit",
        defaultMessage: "Edit"
    },
    rehearsals: {
        id: "choir.meta.details.rehearsals.label",
        defaultMessage: "Rehearsals"
    },
    day: {
        id: "choir.meta.details.rehearsals.day.label",
        defaultMessage: "Day"
    },
    time: {
        id: "choir.meta.details.rehearsals.time.label",
        defaultMessage: "Time"
    },
    type: {
        id: "choir.meta.details.rehearsals.type.label",
        defaultMessage: "Type"
    },
    save: {
        id: "changeDescription.submit",
        defaultMessage: "Save"
    },
    cancel: {
        id: "general.cancel",
        defaultMessage: "Cancel"
    },
    notProvided: {
        id: "general.notProvidedYet",
        defaultMessage: "No provided yet"
    },
});

export default messages;
